export const SELECT_HEAT_EXCHANGER = 'SELECT_HEAT_EXCHANGER';
export const SELECT_ITEM = 'SELECT_ITEM';

export const LOAD_SKETCHES = 'LOAD_SKETCHES';

export const FILTERS_SELECTION_CHANGED1 = 'FILTERS_SELECTION_CHANGED1';
export const FILTERS_CUSTOM_CHANGED = 'FILTERS_CUSTOM_CHANGED';

export const LOAD_USER_PROFILE_DATA = 'LOAD_USER_PROFILE_DATA';
export const LOAD_USER_PROFILE_DATA_SUCCESS = 'LOAD_USER_PROFILE_DATA_SUCCESS';
export const LOAD_USER_PROFILE_DATA_ERROR = 'LOAD_USER_PROFILE_DATA_ERROR';

export const LOAD_CUSTOMER_TRANSLATIONS = 'LOAD_CUSTOMER_TRANSLATIONS';
export const LOAD_CUSTOMER_TRANSLATIONS_SUCCESS = 'LOAD_CUSTOMER_TRANSLATIONS_SUCCESS';
export const LOAD_CUSTOMER_TRANSLATIONS_ERROR = 'LOAD_CUSTOMER_TRANSLATIONS_ERROR';

export const LOAD_CUSTOMER = 'LOAD_CUSTOMER';
export const LOAD_CUSTOMER_SUCCESS = 'LOAD_CUSTOMER_SUCCESS';
export const LOAD_CUSTOMER_ERROR = 'LOAD_CUSTOMER_ERROR';

export const APPLICATION_LANGUAGE_CHANGE = "APPLICATION_LANGUAGE_CHANGE";
export const UNIT_SYSTEM_LANGUAGE_CHANGE = "UNIT_SYSTEM_LANGUAGE_CHANGE";

export const ARTICLE_LOAD = 'ARTICLE_LOAD';
export const ARTICLE_LOAD_SUCCESS = 'ARTICLE_LOAD_SUCCESS';
export const ARTICLE_LOAD_ERROR = 'ARTICLE_LOAD_ERROR';

export const ARTICLES_PORT_CONFIGUATION_LOAD = 'ARTICLES_PORT_CONFIGUATION_LOAD';
export const ARTICLES_PORT_CONFIGUATION_LOAD_SUCCESS = 'ARTICLES_PORT_CONFIGUATION_LOAD_SUCCESS';
export const ARTICLES_PORT_CONFIGUATION_LOAD_ERROR = 'ARTICLES_PORT_CONFIGUATION_LOAD_ERROR';
export const ARTICLES_CHANGE_SELECTION = 'ARTICLES_CHANGE_SELECTION';

export class Application {
    static ERROR_RESET = 'REDUX.App.ResetError';
    static ERROR_WEBAPI = 'REDUX.App.ErrorWebApi';
    static ERROR_USERMADE = 'REDUX.App.UserError';
    static INFO_RESET = 'REDUX.App.ResetInfoMessage';
    static INFO_MSG = 'REDUX.App.INFO_MSG';
}

export class Calculation {
    static UPDATE_PARAMETERS = 'Calculation.UPDATE_PARAMETERS';
    static CALCULATE_BEGIN = 'Calculation.REDUX.BEGIN';
    static CALCULATE = 'Calculation.SAGA.PROCESS';
    static CALCULATE_SUCCESS = 'Calculation.REDUX.SUCCESS';
    static INPUTS_HEATEXCHANGERS_LOAD = 'Calculation._INPUTS_HEATEXCHANGERS_LOAD';
    static INPUTS_HEATEXCHANGERS_SUCCESS = 'REDUX.Calculation.INPUTS_HEATEXCHANGERS_SUCCESS';
    static INPUTS_HEATEXCHANGERS_ERROR = 'REDUX.Calculation.INPUTS_HEATEXCHANGERS_ERROR';

    static INPUTS_LOAD = 'Calculation.INPUTS_LOAD';
    static INPUTS_LOAD_SUCCESS = 'Calculation.INPUTS_LOAD_SUCCESS';
    static INPUTS_LOAD_ERROR = 'Calculation.INPUTS_LOAD_ERROR';

    static SET_INPUTS_VALIDITY = 'Calculation.REDUX.SetInputFormValidity';
    static OUTPUT_COLUMNS_CHANGE = 'OUTPUT_COLUMNS_CHANGE';
}
